import { Inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UI_CONFIG } from '@shared/ui/ui.config';
import { UiConfig } from '@shared/ui/ui.interface';
import escapeRegExp from 'lodash-es/escapeRegExp';
import {
  emojiKeyToImageMap,
  emojiLongnameList,
  emojiShortnameList,
} from './map';

type EmojiSize = 'small' | 'large';

@Pipe({ name: 'emoji' })
export class EmojiPipe implements PipeTransform {
  emojiMap: { [key: string]: string } = emojiKeyToImageMap;

  escapedEmojiShortnameList: string[] = emojiShortnameList.map(
    (shortname: string) => escapeRegExp(shortname),
  );

  shortNameFilter = this.escapedEmojiShortnameList.join('|');
  longNameFilter = emojiLongnameList.join('|');

  emojiRegex = new RegExp(
    `(${this.shortNameFilter}|${this.longNameFilter})`,
    'g',
  );

  constructor(
    private sanitized: DomSanitizer,
    @Inject(UI_CONFIG) private uiConfig: UiConfig,
  ) {}

  // TODO consider using dumb component instead
  getStyleString(emojiSize: EmojiSize) {
    return emojiSize === 'small'
      ? `style="width: 20px; height: 20px; margin-bottom: -4px"`
      : `style="width: 36px; height: 36px; margin-bottom: -7px"`;
  }

  transform(value: string, emojiSize: EmojiSize = 'small') {
    const filteredValue = value.replace(
      this.emojiRegex,
      match =>
        `<img ${this.getStyleString(emojiSize)} src=${this.uiConfig
          .assetsBaseUrl}${this.emojiMap[match]} />`,
    );

    return this.sanitized.bypassSecurityTrustHtml(filteredValue);
  }
}

export { emojiLongnameList };



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/emoji/emoji.pipe.ts